import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FinalPricingCTA() {
  return <section className="py-16 md:py-24 bg-transparent text-[#2f3a2c] text-center relative overflow-hidden" data-id="element-58">
      <div aria-hidden="true" className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-59">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] rounded-full bg-[#d4a017]/10 blur-[100px]" data-id="element-60" />
      </div>

      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-61">
        <div className="mb-5" data-id="element-62">
          <span className="inline-block px-6 py-2.5 rounded-full border border-white/40 bg-[#7d8a6e] text-white font-semibold tracking-[0.18em] uppercase text-xs" data-id="element-63">
            Última Oportunidad
          </span>
        </div>
        <h2 className="text-3xl md:text-5xl font-bold font-heading text-[#2f3a2c] mb-6 leading-tight" data-id="element-64">
          Tu hijo merece volver a clases con ventaja, no con retroceso.
        </h2>
        <p className="text-lg text-slate-600 mb-10 max-w-2xl mx-auto" data-id="element-65">
          No dejes que las vacaciones de invierno borren meses de esfuerzo.
          Recuperá el control con un sistema que ya funciona y que no te va a
          robar ni un minuto de tu tiempo libre.
        </p>

        <div className="bg-white border border-amber-100 rounded-3xl p-8 shadow-lg shadow-black/5 max-w-xl mx-auto mb-8" data-id="element-66">
          <h3 className="font-bold text-[#2f3a2c] mb-2 text-[12px]" data-id="element-67">
            Pack Completo: Expedición 5to Grado + 5 Bonos GRATIS
          </h3>
          <div className="text-slate-400 line-through mb-2" data-id="element-68">$74.940 ARS</div>
          <div className="text-4xl font-bold text-[#c06a52] mb-6" data-id="element-69">
            $19.990 ARS
          </div>

          <motion.a href="https://expedicion-5to-grado.impultienda.ar/checkout" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="flex items-center justify-center gap-3 w-full bg-[#c06a52] hover:bg-[#b35f48] text-white font-bold text-lg md:text-xl px-6 py-5 rounded-full shadow-lg shadow-[#c06a52]/30 transition-colors mb-4" data-id="element-70">
            <span className="text-center" data-id="element-71">
              🚀 SÍ, QUIERO EMPEZAR LA EXPEDICIÓN HOY
            </span>
            <ArrowRight className="w-6 h-6 flex-shrink-0" data-id="element-72" />
          </motion.a>
        </div>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-4 text-sm text-slate-500 font-medium" data-id="element-73">
          <span data-id="element-74">
            <span aria-hidden="true" data-id="element-75">⭐⭐⭐⭐⭐</span> 4.9/5 — Reseñas
            verificadas
          </span>
          <span aria-hidden="true" className="hidden sm:inline text-slate-300" data-id="element-76">
            |
          </span>
          <span data-id="element-77">
            <span aria-hidden="true" data-id="element-78">🛡️</span> Garantía de 7 Días — Riesgo Cero
          </span>
        </div>
      </div>
    </section>;
}